import {selection} from "d3-selection";

var Selection = selection.prototype.constructor;

export default function() {
  return new Selection(this._groups, this._parents);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-transition/src/transition/selection.js
// module id = 273
// module chunks = 0